import { useContext } from "react";
import MainLayout from "../../layouts/main.layout";
import { setAuthorization } from "../../services/api";
import { AuthContext } from "../../core/context/AuthContext";
import { useJwt } from "react-jwt";

const AdminProtected = () => {
  const { user, setUser } = useContext(AuthContext);
  const { isExpired } = useJwt(user?.token ?? "");

  if (isExpired) {
    setUser(null);
  }

  if (user === null) {
    window.location.href = process.env.REACT_APP_SITE_HOST ?? "https://celetus.com";
    return <></>;
  }

  setAuthorization(user.token);

  return <MainLayout />;
};

export default AdminProtected;
